document.addEventListener('DOMContentLoaded', () => {
    console.log("ACOWEBS PRODUCT ADDONS");
    const formNode = document.querySelector('product-form.product-form form[action="/cart/add"]');
    console.log("ACOWEBS formNode => ", formNode);
    handleBuyNowValidation(formNode);
});

function handleBuyNowValidation(formNode) {
  // Get buy now button and form
  const buyNowButton = document.querySelector('.shopify-payment-button__button.shopify-payment-button__button--unbranded');
  const buyNowForm = document.querySelector('.product-form-buy-button form[action="/cart/add"]');
  const mainForm = document.querySelector('product-form.product-form form[action="/cart/add"]');

  console.log("ACOWEBS buyNowButton => ", buyNowButton);
  console.log("ACOWEBS buyNowForm => ", buyNowForm);
  console.log("ACOWEBS mainForm => ", mainForm);

  if (!buyNowButton || !buyNowForm) {
    console.log("ACOWEBS Buy now button or form not found, exiting");
    return;
  }

  let isProcessingClick = false;

  const handleBuyNowClick = (e) => {
    console.log("ACOWEBS handleBuyNowClick triggered");
    
    // Check if ACO hidden fields are already present in buy now form
    const existingAcoFields = buyNowForm.querySelectorAll('input[name*="properties["]');
    console.log("ACOWEBS Existing ACO fields in buy now form:", existingAcoFields.length);
    
    if (existingAcoFields.length > 0) {
      console.log("ACOWEBS ACO fields already present, allowing normal buy now flow");
      // Fields are already there, let the normal buy now process continue
      return;
    }
    
    // Check if we're already processing to avoid loops
    if (isProcessingClick) {
      console.log("ACOWEBS Click is being processed, allowing normal flow");
      return;
    }
    
    console.log("ACOWEBS No ACO fields found, proceeding with validation and field copying");
    
    e.preventDefault();
    e.stopPropagation();
    
    console.log("ACOWEBS Buynow clicked - validation started");
    
    // Trigger validation check through wcpaTrigger event
    const wcpaTriggerEvent = new Event('wcpaTrigger');
    document.dispatchEvent(wcpaTriggerEvent);
    console.log("ACOWEBS wcpaTrigger event dispatched");

    // Wait for validation to complete
    setTimeout(() => {
      console.log("ACOWEBS Validation timeout completed, checking validity");
      
      // Check if form is valid (you'll need to implement this check based on your validation system)
      const errorElement = document.querySelector('.wcpa_form_error');
      const isValid = errorElement === null;
      
      console.log("ACOWEBS Validation result - isValid:", isValid);
      console.log("ACOWEBS Error element found:", errorElement);

      if (isValid) {
        console.log("ACOWEBS Form is valid, proceeding with buy now");
        
        // Copy all hidden fields from main form to buy now form
        const hiddenFields = mainForm.querySelectorAll('input[type="hidden"]');
        console.log("ACOWEBS Found hidden fields in main form:", hiddenFields.length);
        
        let copiedFieldsCount = 0;
        let updatedFieldsCount = 0;
        
        hiddenFields.forEach((field, index) => {
          const name = field.getAttribute('name');
          const value = field.value;
          
          console.log(`ACOWEBS Hidden field ${index}:`, { name, value });
          
          if (name && name.startsWith('properties[')) {
            console.log(`ACOWEBS Processing field: ${name}`);
            
            // Check if field already exists in buy now form
            const existingField = buyNowForm.querySelector(`input[name="${name}"]`);
            
            if (existingField) {
              console.log(`ACOWEBS Updating existing field: ${name}`, { oldValue: existingField.value, newValue: value });
              existingField.value = value;
              updatedFieldsCount++;
            } else {
              console.log(`ACOWEBS Creating new field: ${name}`);
              const newField = field.cloneNode(true);
              buyNowForm.appendChild(newField);
              copiedFieldsCount++;
            }
          }
        });
        
        console.log(`ACOWEBS Fields processed - Created: ${copiedFieldsCount}, Updated: ${updatedFieldsCount}`);
        
        // Log all fields in buy now form before submission
        const allBuyNowFields = buyNowForm.querySelectorAll('input');
        console.log("ACOWEBS All fields in buy now form before submission:", allBuyNowFields.length);
        allBuyNowFields.forEach((field, index) => {
          console.log(`ACOWEBS Buy now form field ${index}:`, {
            name: field.name,
            type: field.type,
            value: field.value
          });
        });

        console.log("ACOWEBS Setting processing flag and clicking buy now button");
        
        // Set flag to prevent re-processing
        isProcessingClick = true;
        
        // Trigger buy now button click
        setTimeout(() => {
          try {
            buyNowButton.click();
            console.log("ACOWEBS Buy now button clicked successfully");
          } catch (error) {
            console.error("ACOWEBS Error clicking buy now button:", error);
          }
          
          // Reset flag after a delay
          setTimeout(() => {
            isProcessingClick = false;
            console.log("ACOWEBS Processing flag reset");
          }, 1000);
        }, 50);
        
      } else {
        console.log("ACOWEBS Form validation failed");
        
        // If validation fails, scroll to the error
        if (errorElement) {
          console.log("ACOWEBS Scrolling to error element");
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          console.log("ACOWEBS No error element found to scroll to");
        }
      }
    }, 100); // Give time for validation to complete
  };

  console.log("ACOWEBS Adding event listeners to buy now elements");

  // Add event listener to buy now button
  buyNowButton.addEventListener('click', handleBuyNowClick, { capture: true });
  console.log("ACOWEBS Event listener added to buy now button");

  // Add event listener to buy now form
  buyNowForm.addEventListener('submit', handleBuyNowClick, { capture: true });
  console.log("ACOWEBS Event listener added to buy now form");

  // Watch for dynamically added buy now buttons (commented out as per original)
  // const observer = new MutationObserver((mutations) => {
  //   console.log("ACOWEBS MutationObserver triggered");
  //   mutations.forEach((mutation) => {
  //     mutation.addedNodes.forEach((node) => {
  //       if (node.nodeType === 1) { // ELEMENT_NODE
  //         const addedBuyNowBtn = node.matches('.shopify-payment-button__button') ? 
  //           node : node.querySelector('.shopify-payment-button__button');
  //         if (addedBuyNowBtn) {
  //           console.log("ACOWEBS Adding event listener to dynamically added buy now button");
  //           addedBuyNowBtn.addEventListener('click', handleBuyNowClick, { capture: true });
  //         }
  //       }
  //     });
  //   });
  // });

  // observer.observe(document.body, {
  //   childList: true,
  //   subtree: true
  // });
  
  console.log("ACOWEBS Buy now validation setup completed");
}